import React from 'react'

// Components
import Header from '../components/Header'
import Footer from '../components/Footer'

const midiaPage = () =>
  <div>
    <Header name="site-header" style={{paddingBottom: '150px', marginBottom: '-130px'}}>
      <div className="container">
        <div className="grid-center">
           <div className="col-8_md-10 grid-column content center">
             <h1>
               O que estão falando da gente por aí?
             </h1>
             <p>Confira uma série de materiais onde o Talkative foi citado:</p>
           </div>
        </div>
      </div>
    </Header>
    <section className="midia-section" style={{marginBottom: '100px'}}>
      <div className="container">
        <div className="grid-noGutter-equalHeight-center box-list">
          <div className="col-4_xs-12 box quote auto">
            <div>
              <p>É importante questionar o quanto o surgimento do comércio virtual assume importantes posições.</p>
              <img src={require('../sass/images/logo-folha.png')} alt=""/>
            </div>
          </div>

          <div className="col-4_xs-12 box quote auto">
            <div>
              <p>É importante questionar o quanto o surgimento do comércio virtual assume importantes posições.</p>
              <img src={require('../sass/images/logo-exame.png')} alt=""/>
            </div>
          </div>

          <div className="col-4_xs-12 box quote auto">
            <div>
              <p>É importante questionar o quanto o surgimento do comércio virtual assume importantes posições.</p>
              <img src={require('../sass/images/logo-g1.png')} alt=""/>
            </div>
          </div>


          <div className="col-4_xs-12 box quote auto">
            <div>
              <p>É importante questionar o quanto o surgimento do comércio virtual assume importantes posições.</p>
              <img src={require('../sass/images/b9-logo-1.png')} alt=""/>
            </div>
          </div>

          <div className="col-4_xs-12 box quote auto">
            <div>
            <p>É importante questionar o quanto o surgimento do comércio virtual assume importantes posições.</p>
            </div>
          </div>

          <div className="col-4_xs-12 box quote auto">
            <div>
            <p>É importante questionar o quanto o surgimento do comércio virtual assume importantes posições.</p>
            </div>
          </div>


          <div className="col-4_xs-12 box quote auto">
            <div>
            <p>É importante questionar o quanto o surgimento do comércio virtual assume importantes posições.</p>
            </div>
          </div>

          <div className="col-4_xs-12 box quote auto">
            <div>
            <p>É importante questionar o quanto o surgimento do comércio virtual assume importantes posições.</p>
            </div>
          </div>

          <div className="col-4_xs-12 box quote auto">
            <div>
            <p>É importante questionar o quanto o surgimento do comércio virtual assume importantes posições.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>

export default midiaPage



// WEBPACK FOOTER //
// ./src/pages/midia.js